import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from '../molecules/Footer'
import Navbar from '../molecules/Navigation/Navbar'
import FloatingWhatsApp from "../atoms/FloatingWhatsApp";


const DefaultLayout = () => {
    return (
        <>
            <Navbar />
            <main>
                <Outlet />
            </main>
            <FloatingWhatsApp />
            <Footer />
        </>
    )
}

export default DefaultLayout